import React from "react";

const EditContext = React.createContext()

export default EditContext